import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/guest`;

export type SignContractLineItem = {
  label: string;
  size: string | null;
  price: string | number;
  price_formatted: string;
  publication: string;
  issue: string;
};

export type SignContractPayload = {
  id: number;
  status: 'draft' | 'sent' | 'signed';
  body: string;
  contract_from: number;
  contract_from_name: string;
  terms_and_conditions: string | null;
  purchase_order_number: string | null;
  vat_number: string | null;
  company_name: string;
  company_logo: string | null;
  signer_name: string | null;
  signer_email: string | null;
  signed_at: string | null;
  sent_at: string | null;
  proposal: {
    id: number;
    contact_name: string | null;
    contact_email: string | null;
    currency: string;
    total_price: number;
    total_price_formatted: string;
    line_items: SignContractLineItem[];
  } | null;
};

export const getSignContract = async (token: string): Promise<SignContractPayload> => {
  const response = await axios.get(`${API_URL}/sign/${token}`);
  return response.data;
};

export const submitSignContract = async (
  token: string,
  data: {
    signer_name: string;
    agreed: boolean;
    purchase_order_number?: string;
    vat_number?: string;
  }
): Promise<SignContractPayload> => {
  const response = await axios.post(`${API_URL}/sign/${token}`, data);
  return response.data;
};
